module.exports = __webpack_public_path__ + "static/media/empty_cart.acbcc9ab.png";